(function() {
    'use strict';
    angular.module('app')
        .controller('tsunCourseController', tsunCourseController);

    function tsunCourseController(modalService, trainingInnerService, userInfo, urlParam, $q, $rootScope, $scope, $uibModal) {
        var vm = this;
        //vm.selectedMenu = selectedMenu;
        vm.openCourseDetail = openCourseDetail;
        vm.addToShoppingCar = addToShoppingCar;
        vm.enroll = enroll;
        vm.openCourseCategorySelector = openCourseCategorySelector;
        vm.isMobile = modalService.isMobile();
        //==Main==
        onInit();
        //========
        function onInit() {
            menuInit();
            dataInit();
            logicInit();

            $scope.$watch('isSmallView', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                menuSlide();
            });
            $scope.$watch('vm.data.courseListFilter.length', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                if (!newValue) { newValue = 0; }
                vm.view.courseEmpty = newValue < 1;
            });
        }

        function menuInit() {
            if (location.href.indexOf('sessionId') > 0 || location.href.indexOf('courseId') > 0) {
                console.log('sessionId:', queryString('sessionId'));
                console.log('courseId:', queryString('courseId'));
                var sessionId = queryString('sessionId');
                var courseId = queryString('courseId');

                if (!sessionId || !courseId) {
                    sessionStorage.setItem('menuSerilNo', '');
                    sessionStorage.setItem('menuSerilNo', -9903);
                }
            }
        }

        function dataInit() {
            vm.data = {
                urlParam: urlParamFormat(urlParam) || {}, //.........網頁傳入的參數
                collectionList: null,
                courseList: [], //...................................課程資料清單
                courseListFilter: [], //.............................課程資料清單於Filter處理後結果
                courseCatagories: [],
                courseCatagoriesSelectedItemName: $rootScope.translate.commonAll,
            };
            vm.viewShow = {
                slides: []
            };
            vm.view = {
                isMobile: modalService.isMobile(),
                courseEmpty: false, //.........查無資料判定
                pageLoading: false, //.........頁面讀取中
                pageLoaded: false, //..........頁面讀取完畢
            };
            vm.menuIndex = -1;
            vm.menuChildIndex = -1;
        }

        function logicInit() {
            vm.view.pageLoading = true;
            loadMenu()
                .then(function(catagoryId) {
                    menuSlide();
                    if (!catagoryId) { return; }
                    return loadCourseList(-1, true);
                }).then(function() {
                    vm.data.courseList = _.filter(vm.data.courseList, function(courseItem) {
                        var checkCourseID = vm.data.urlParam.courseid || courseItem.courseId;
                        var checkSessionID = vm.data.urlParam.sessionid || courseItem.sessionId;
                        // console.log("courseItem", courseItem);
                        // console.log("checkCourseID", checkCourseID);
                        // console.log("checkSessionID", checkSessionID);
                        return (courseItem.courseId === checkCourseID && courseItem.sessionId === checkSessionID);
                    });
                }).then(function() {
                    vm.view.courseEmpty = vm.data.courseList.length < 1;
                    vm.view.pageLoading = false;
                    vm.view.pageLoaded = true;
                });
        }

        function urlParamFormat(sourceData) {
            if (!sourceData) { return null; }
            var params = {};
            _.forEach(sourceData, function(value, key) {
                var keyString = (key + '').toLowerCase();
                switch (keyString) {
                    case 'courseid':
                        params[keyString] = parseInt(value);
                        break;
                    case 'sessionid':
                        params[keyString] = parseInt(value);
                        break;
                    default:
                        break;
                }
            });
            return params;
        }

        function menuSlide() {
            var slideNum = 4;
            if ($rootScope.isSmallView) {
                slideNum = 4;
            }
            vm.viewShow.slides = _.chunk(vm.data.courseCatagories, slideNum);
            _.forEach(vm.viewShow.slides, function(slideItem) {
                for (var index = slideItem.length; index < slideNum; index++) {
                    slideItem.push({
                        categoryId: null,
                    });
                }
            });
            //console.logconsole.log('menuSlide:', vm.viewShow.slides);
        }

        function loadMenu(langItem) {
            //console.log('langItem:',langItem);
            return trainingInnerService.getMenu(langItem).then(function(data) {
                // console.log("loadMenu data:", data);
                // data.unshift({ categoryId: "-1", categoryName: $rootScope.translate.commonAll });
                // console.log("loadMenu data:", data);
                vm.data.courseCatagories = data;
                if (data.length < 1) { return null; }
                vm.menuIndex = -1;
                vm.menuChildIndex = -1;
                return -1;
                //return data.data[0].categoryId;
            });
        }

        function loadCourseList(courseCategory, loadCollection) {
            // var courseList = trainingInnerService.getCourseList(courseCategory);
            //console.log('courseCategory:',courseCategory);
            return trainingInnerService.getCourseListAll(courseCategory)
                .then(function(courseList) {
                    console.log("getCourseListAll:", courseList);
                    var promisList = [
                        trainingInnerService.checkCourseWithMenu(courseList, vm.data.courseCatagories)
                    ];

                    if (loadCollection) {
                        promisList.push(loadUserCollection());
                    }
                    return $q.all(promisList).then(function(data) {
                        //console.log("getCourseListAll:", data[0]);
                        return data[0]; //courseList
                    });
                })
                .then(function(courseListChecked) {
                    //console.log('vm.data.courseList:',courseListChecked);
                    _.forEach(courseListChecked, function(data) {
                        //console.log('sTime:',data.courseTime);
                        data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                        //console.log('data:',data.courseTime);
                    });
                    vm.data.courseList = courseListChecked;
                    collectionCheck();
                    return courseListChecked;
                });
        }

        function loadUserCollection() {
            var collectionList = trainingInnerService.getCollectionList();
            return collectionList.then(function(data) {
                vm.data.collectionList = data;
                return data;
            });
        }
        // select menu
        // function selectedMenu(categoryId) {
        //     // var isSameCourse =
        //     //     (vm.menuIndex === index) &&
        //     //     (vm.menuChildIndex = menuChildIndex);
        //     // if (isSameCourse) {
        //     //     //如果再度點選篩選中的類別，就取消選取，呈現所有資料。
        //     //     vm.menuIndex = -1;
        //     //     vm.menuChildIndex = -1;
        //     //     loadCourseList(-1);
        //     //     return;
        //     // }
        //     // vm.menuIndex = index;
        //     // vm.menuChildIndex = menuChildIndex;
        //     //loadCourseList(categoryId);
        // }

        // select enroll
        function enroll(item) {
            console.log('enroll');
            var confirmDialog = modalService.confrimDialog({
                confirmContent: $rootScope.translate.tsunEnrollInfoNoQuestion,
                promiseAction: () => {
                    return trainingInnerService.hasEnrollQuestion(item).then(function(result) {
                        if (!result) {
                            return trainingInnerService.postSessionAction(item, 'Enroll')
                                .then(function(result) {
                                    if (!result) { return; }
                                    enrollSuccess(item);
                                })
                                .then(function() {
                                    //clear url param
                                    console.log('enrollSuccess');
                                    if(location.href.toLowerCase().indexOf('sessionid') > 0 
                                    || location.href.toLowerCase().indexOf('courseid') > 0){
                                        console.log("current url:", location.href);
                                        //2023-07-24 Johnson 資安2023
                                        location.href = eval(function(p,a,c,k,e,r){e=function(c){return c.toString(a)};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('`${2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.9(\'a\')}`.1(/</g,\'&b\').1(/>/g,\'&c\').1(/"/g,\'&d\').1(/\'/g,\'&#e\').1(/[<>!]|(\\(\\))|((f|h|i)\\j*\\(.*\\))/g,\'\');',20,20,'|replace|location|href|split|tsu|course|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for||while|if|s'.split('|'),0,{}))
                                    }
                                });
                        } else {
                            var settingModel = {
                                isEnroll: true
                            };
                            var modal = modalService.courseDetail(item, settingModel);
                            modal.result.then(function(result) {
                                    if (!result) { return; }
                                    enrollSuccess(item);
                                })
                                .then(function() {
                                    //clear url param
                                    console.log('enrollSuccess');
                                    if(location.href.toLowerCase().indexOf('sessionid') > 0 
                                    || location.href.toLowerCase().indexOf('courseid') > 0){
                                        console.log("current url:", location.href);
                                        //2023-07-24 Johnson 資安2023
                                        location.href = eval(function(p,a,c,k,e,r){e=function(c){return c.toString(a)};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('`${2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.9(\'a\')}`.1(/</g,\'&b\').1(/>/g,\'&c\').1(/"/g,\'&d\').1(/\'/g,\'&#e\').1(/[<>!]|(\\(\\))|((f|h|i)\\j*\\(.*\\))/g,\'\');',20,20,'|replace|location|href|split|tsu|course|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for||while|if|s'.split('|'),0,{}))
                                    }
                                });
                        }
                    });
                }
            });



            // confirmDialog.result.then(function(result) {
            //     result = !!result;
            //     if (result !== true) {
            //         return;
            //     }
            //     trainingInnerService.hasEnrollQuestion(item).then(function(result) {
            //         if (!result) {
            //             trainingInnerService.postSessionAction(item, 'Enroll')
            //                 .then(function(result) {
            //                     if (!result) { return; }
            //                     enrollSuccess(item);
            //                 });
            //         } else {
            //             var settingModel = {
            //                 isEnroll: true
            //             };
            //             var modal = modalService.courseDetail(item, settingModel);
            //             modal.result.then(function(result) {
            //                 if (!result) { return; }
            //                 enrollSuccess(item);
            //             });
            //         }
            //     });
            // });

        }

        function openCourseDetail(item) {
            var modal = modalService.courseDetail(item);
            modal.result.then(function(data) {
                if (data) { enrollSuccess(item); }
            });
        }

        function enrollSuccess(item) {
            trainingInnerService.delCollection(item, false).then(function() {
                var itemIndex = _.findIndex(vm.data.courseList, { sessionId: item.sessionId });
                if (itemIndex > -1) {
                    vm.data.courseList.splice(itemIndex, 1);
                }

            });
        }

        function addToShoppingCar(item) {
            trainingInnerService.addCollection(item)
                .then(function() {
                    // console.log("vm.data.collectionList",vm.data.collectionList);
                    if (!vm.data.collectionList) {
                        vm.data.collectionList = [];
                    }
                    vm.data.collectionList.push({ collectionSessionId: item.sessionId });
                    item.isAdd = true;
                });
            //trainingInnerService.addToShoppingCar(item);
        }

        function collectionCheck() {
            //console.log("vm.data.collectionList", vm.data.collectionList);
            _.forEach(vm.data.courseList, function(courseItem) {
                var indexFind = _.findIndex(vm.data.collectionList, {
                    collectionSessionId: courseItem.sessionId
                });
                courseItem.isAdd = (indexFind >= 0);
            });
            return vm.data.courseList;
        }

        function openCourseCategorySelector() {
            var item = vm.data.courseCatagories;
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/courseCategorySelector.html',
                controller: 'courseCategorySelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    categoryItem: function() {
                        return item;
                    },
                }
            });
            //這個則是接收傳回來的值
            result.result.then(function(result) {
                vm.data.courseCatagoriesSelectedItemName = result[0].categoryName;
                loadCourseList(result[0].categoryId);
            });
        }
    }
})();